

















import Vue from 'vue'

export default Vue.extend({
  props: {
    icon: {
      type: String,
      required: true
    },
    clickable: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    clickImage() {
      if (this.clickable) {
        this.$emit('click-image')
      }
    }
  }
})
